import axios from '../../http_v2'
export default {
    get: (data) => {
        return axios.post('activityservice/socialization/query', data)
    },
    update:  (data) => {
        return axios.post('activityservice/socialization/update', data)
    },
    add:  (data) => {
        return axios.post('activityservice/socialization/insert', data)
    }
}
